module.exports = __webpack_public_path__ + "static/logo-a71c365236e0c6f9b83bf587d117131b.svg";